var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIteminfoProductsScraper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:url(#linear-gradient);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 4.44048,
    y1: 0.88619,
    x2: 81.05694,
    y2: 83.47983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff2a5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328,
    stopColor: "#fff254"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48367,
    stopColor: "#fff22d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cdc82d"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M78.17747,88.61091c-18.78499,2.12302-37.56996,2.12302-56.35494,0-5.49081-.62055-9.8129-4.94264-10.43345-10.43345-2.12301-18.78497-2.12301-37.56995,0-56.35493.62055-5.49081,4.94265-9.8129,10.43346-10.43345,18.78498-2.12301,37.56995-2.12301,56.35494,0,5.49081.62055,9.8129,4.94264,10.43346,10.43345,2.12301,18.78497,2.12301,37.56995,0,56.35492-.62055,5.49081-4.94265,9.8129-10.43345,10.43345Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M80.703,51.74658l-16.52637,1.78552-.23346-2.16058c-.06885-.63721-.57861-1.11981-1.19293-1.17725-.08777-.00836-.17773-.008-.26886.00183l-9.64728,1.0423c-.72772.07867-1.25397.7323-1.17529,1.46002l.1955,1.80975c.00067.00598.00293.01135.00366.01727l1.78979,16.56573c.07861.72778.7323,1.25397,1.46002,1.17535l2.38641-.25787c.09857.01196.19916.01581.30212.0047l9.64734-1.0423c.72772-.07861,1.25391-.7323,1.17529-1.46002l-.1955-1.80975c-.06036-.55872-.46075-.99561-.97235-1.13422l.72217-.07806c.72772-.07861,1.25391-.7323,1.17529-1.46002l-.1955-1.80969c-.05896-.54565-.44116-.97791-.93542-1.12701l.78955-.08527c.72772-.07861,1.25391-.7323,1.17529-1.46008l-.19556-1.80969c-.07861-.72772-.7323-1.25391-1.46002-1.17529l-3.86975.41809-.00031-.00287,16.52637-1.78552c.72778-.07867,1.25397-.7323,1.17535-1.46002l-.19556-1.80969c-.07861-.72778-.7323-1.25397-1.46002-1.17535Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M64.7937,36.43915l-5.6098-3.23877-18.48682,10.67346,6.79388,3.9223c.36639.21155.81787.21155,1.18433,0l16.11835-9.30554c.78961-.45587.78961-1.59558.00006-2.05145Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M31.37299,38.49066l5.13184,2.96283,18.48712-10.67334-6.31641-3.64679c-.36646-.21155-.81793-.21155-1.18433,0l-16.11823,9.30591c-.78961.45587-.78961,1.59552,0,2.05139Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M27.50055,43.08911v18.68835c0,.41119.21936.7912.5755.99677l16.18445,9.34412c.7674.44305,1.72656-.11072,1.72656-.99677v-18.68823c0-.41119-.21936-.7912-.5755-.99677l-6.87177-3.96753v9.87964l-4.19208-2.17682v-10.12317l-5.12067-2.95642c-.76733-.44305-1.7265.11072-1.7265.99683Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIteminfoProductsScraper);
export default __webpack_public_path__ + "static/media/iteminfo-products-scraper.32aec9048afe716d20766d73f62e4133.svg";
export { ForwardRef as ReactComponent };